import { AbstractElementalDep } from '../../types/lux'

export default AbstractElementalDep

const ensureDepsMap = (combinationElement, combinationId) => {
  /** @type {!Object<string, AbstractElementalDep>} */
  let depsMap = combinationElement[DEPS]
  if (!depsMap) {
    depsMap = {
      [combinationId]: null,
    }
    combinationElement[DEPS] = depsMap
  }
  return depsMap
}

const READY = () => {}

export const DEPS = Symbol('guest.maurice::deps')

/** @constructor @extends {AbstractElementalDep} @suppress {checkTypes} */ function _AbstractElementalDep() {}
AbstractElementalDep.__implement(
  _AbstractElementalDep.prototype = /** @type {!AbstractElementalDep} */ ({
    initialiser({ combinatorSelector, ready = READY, combinationId, combinationElement, forCombinator = false, alreadyConstructed } = {}) {
      if (!combinationElement && combinatorSelector) combinationElement = document.querySelector(combinatorSelector)
      if (!combinationElement) return
      this.combinationElement = combinationElement

      if (!combinationId) return
      this.ready = ready

      const depsMap = ensureDepsMap(combinationElement, combinationId)

      if (forCombinator) {
        depsMap[combinationId] = this
      } else {
        // only deal with root combination dependency right now
        let combinator = depsMap[combinationId] // register the combination element as dependency
        if (!combinator) {
          combinator = new AbstractElementalDep({ combinationId, combinationElement, forCombinator: true })
          depsMap[combinationId] = combinator
        }
        this.deps.push(combinator)
        this.combinator = combinator
      }
      setTimeout(() => {
        this.waitForDeps()
        if (alreadyConstructed) this.constructed()
      }, 1)
    },
    constructed() {
      const{asIElementalDep:{combinationId}}=this
      this.__$childConstructed = true
      this.combinationElement.dispatchEvent(new Event(`${combinationId}-${__$constructed}`))
    },
    waitForDeps() {
      const {asIElementalDep:{ready,deps,combinationId}} = this
      const Deps = []
      for (const dep of deps) {
        if (dep.__$childConstructed) continue
        Deps.push(dep)
        const cb = () => {
          const { deps: d } = this
          d.splice(d.indexOf(dep), 1)
          if (!d.length) {
            ready(this.combinator)
          }
          dep.combinationElement.removeEventListener(`${combinationId}-${__$constructed}`, cb)
        }
        dep.combinationElement.addEventListener(`${combinationId}-${__$constructed}`, cb)
      }
      this.deps = Deps
      if (!Deps.length) ready(this.combinator)
    },
  }),
)

/** @type {guest.maurice.extractCombinator} */
export const extractCombinator = (init) => {
  let {combinatorSelector='',combinationId,combinationElement} = init
  if (!combinationElement && !combinatorSelector) {
    throw new Error('Either pass a combinationElement, or a combinatorSelector to query for it.')
  }
  else if (!combinationElement) combinationElement = document.querySelector(combinatorSelector)

  /** @type {AbstractElementalDep} */
  let combinator = null
  const map = combinationElement[DEPS]
  if (map) {
    combinator = map[combinationId]
  }
  if (!combinator) {
    combinator = new AbstractElementalDep(init)
  }
  return combinator
}

/** @noinline */
const __$constructed = '__$constructed'